import styled from "@emotion/styled"

const ArticleAsideTabsColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding-top: 15px;
`

export default ArticleAsideTabsColumn
